// Klaviyo Back In Stock – collection page cards
// Opens the same BIS form (TFxJQJ) as the product page, with the correct variant context.
document.addEventListener("click", function (e) {
  var btn = e.target.closest(".klaviyo-bis-plp-btn");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var variantId = btn.getAttribute("data-variant-id");
  var productId = btn.getAttribute("data-product-id");

  // Set variant context so the form submission subscribes to the right variant
  if (window.klaviyo) {
    window.klaviyo.push([
      "back_in_stock",
      {
        variant: variantId,
        product: productId,
      },
    ]);
  }

  // Open the Back In Stock form directly by form ID
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(["openForm", "TFxJQJ"]);
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".banner-scent-notes").forEach((banner) => {
    const notes = banner.querySelectorAll(".note");
    if (notes.length > 3) {
      banner.classList.add("more-than-3");
    }
  });
});

// login
// document.addEventListener("DOMContentLoaded", function () {
//   // Header account-popup
//   $(".login_popup").click(function () {
//     if ($(this).hasClass("active")) {
//       // If the login popup is already active, we should close it
//       $(this).removeClass("active");
//       $(".customer-account").addClass("hidden");
//       $(".customer-account").removeClass("login-left");
//       $("body").removeClass("overflow-hidden");
//       $("#shopify-section-account-popup").hide();
//       $(".ctm-login-modal-bg").removeClass("active");
//     } else {
//       // If the login popup is not active, we should open it
//       $(this).addClass("active");
//       $(".customer-account").removeClass("hidden");
//       $("#shopify-section-account-popup").show();
//       $(".ctm-login-modal-bg").addClass("active");
//       $(".customer-account").addClass("login-left");
//       $("body").addClass("overflow-hidden");
//     }
//   });

//   $(".ctm-login-modal-bg").click(function () {
//     $(this).removeClass("active");
//     $(".customer-account").addClass("hidden");
//     $(".customer-account").removeClass("login-left");
//     $(".login_popup").removeClass("active");
//     $("body").removeClass("overflow-hidden");
//     $("#shopify-section-account-popup").hide();
//   });

//   $("#login-none").click(function () {
//     $(".login-cta").addClass("d-none");
//     $(".reset-password").removeClass("d-none");
//   });
//   $("#recover-cancel").click(function () {
//     $(".login-cta").removeClass("d-none");
//     $(".reset-password").addClass("d-none");
//   });

//   $("#regi_forgot_pass").click(function () {
//     $("#img-1").addClass("current");
//     $("#tab-1").addClass("current");
//     $("#login").addClass("current");
//     $("#img-2").removeClass("current");
//     $("#tab-2").removeClass("current");
//     $("#signup").removeClass("current");
//   });
//   $("#regi-recover-cancel").click(function () {
//     $(".reset-password").addClass("d-none");
//     $(".forgot-block-area").removeClass("d-none");
//   });

//   // popup tabbing
//   $(".tab-heading ul li a").click(function () {
//     const tab_idd = $(this).attr("data-tab");
//     const tab_img = $(this).attr("data-img");

//     $(".reset-password").addClass("d-none");
//     $(".login-cta").removeClass("d-none");
//     $(".forgot-block-area").removeClass("d-none");

//     $(".tab-heading ul li a").removeClass("current");
//     $(".account-tab.tab-pane").removeClass("current");

//     $(this).addClass("current");
//     $(`#${tab_idd}`).addClass("current");
//     $(`#${tab_img}`).addClass("current");
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  $(
    ".favorite-products__swiper .heading-with-bundle-text .card__heading",
  ).matchHeight();

  // product slider (scoped per gallery so thumbnail nav buttons pair correctly)
  document.querySelectorAll(".ctm-pdp-media-sliders").forEach((root) => {
    const thumbEl = root.querySelector(".ctm_pdp_mainproduct_thumbnail_slider");
    const mainEl = root.querySelector(".ctm_pdp_mainproduct_slider");
    const prevEl = root.querySelector(".ctm-pdp-thumb-nav--prev");
    const nextEl = root.querySelector(".ctm-pdp-thumb-nav--next");
    if (!thumbEl || !mainEl) {
      return;
    }

    const thumbsOptions = {
      direction: "vertical",
      loop: false,
      spaceBetween: 10,
      slidesPerView: 4,
      speed: 600,
      freeMode: false,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        0: {
          direction: "horizontal",
          spaceBetween: 10,
          slidesPerView: 4,
        },
        990: {
          direction: "vertical",
          spaceBetween: 20,
          slidesPerView: 4,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    };

    // The thumbnail nav buttons only render when product.media.size > 4.
    if (prevEl && nextEl) {
      thumbsOptions.navigation = { prevEl, nextEl };
    }

    const swiperThumbs = new Swiper(thumbEl, thumbsOptions);

    new Swiper(mainEl, {
      slidesPerView: 1,
      grabCursor: true,
      draggable: true,
      loop: false,
      spaceBetween: 2,
      speed: 600,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  });
});

// FAQ
document.querySelectorAll(".ctm_multifaq_title_main").forEach((section) => {
  const questions = section.querySelectorAll(".faq_question");
  let previousActiveQuestion = null;

  questions.forEach((question) => {
    const icon = question.querySelector(".icon-shape");

    question.addEventListener("click", (event) => {
      if (previousActiveQuestion && previousActiveQuestion !== question) {
        previousActiveQuestion.classList.remove("active");
        previousActiveQuestion
          .querySelector(".icon-shape")
          .classList.remove("active");
        previousActiveQuestion.nextElementSibling.style.maxHeight = "0";
      }

      question.classList.toggle("active");
      icon.classList.toggle("active");

      const answer = question.nextElementSibling;

      if (question.classList.contains("active")) {
        answer.style.maxHeight = "1000px"; // Fixed max-height
        previousActiveQuestion = question; // Update the previously active question
      } else {
        answer.style.maxHeight = "0";
        previousActiveQuestion = null; // No question is active now
      }
    });

    // Check if the question has the "open" class and add the "active" class accordingly
    if (question.classList.contains("open")) {
      question.classList.add("active");
      icon.classList.add("active");
      const answer = question.nextElementSibling;
      answer.style.maxHeight = "1000px"; // Fixed max-height
      previousActiveQuestion = question; // Set the initially active question
    }
  });
});

// search
function toggleSearchDetails(event) {
  event.preventDefault();
  event.stopPropagation();
  const detailsElement = document.getElementById("search-details");
  detailsElement.hasAttribute("open")
    ? detailsElement.removeAttribute("open")
    : detailsElement.setAttribute("open", "true");
}

function closeSearchDetails() {
  const detailsElement = document.getElementById("search-details");
  detailsElement.removeAttribute("open");
}

// header elements
const userBoxes = document.querySelectorAll(".ctm_account_login");
const menuDrawer = document.getElementById("Details-menu-drawer-container");
const loginModal = document.querySelector(".ctm-login-modal");
const searchDetails = document.getElementById("search-details");
const cartDrawer = document.querySelector("cart-drawer.drawer");
const cartToggle = document.querySelector(".cart-toggle");

function forceCloseMenuDrawer() {
  if (!menuDrawer) return;
  menuDrawer.classList.remove("menu-opening");
  menuDrawer.removeAttribute("open");
  const hw = document.querySelector(".header-wrapper");
  if (hw) {
    hw.classList.remove("menu-drawer-active", "menu-drawer-closing");
  }
}

// Observe each userBox for class changes
userBoxes.forEach((userBox) => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.attributeName === "class" &&
        userBox.classList.contains("active")
      ) {
        searchDetails.removeAttribute("open");
        cartDrawer?.classList.remove("active");
        forceCloseMenuDrawer();
      }
    });
  });
  observer.observe(userBox, { attributes: true });
});

// Observe when search is opened
const searchObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (
      mutation.attributeName === "open" &&
      searchDetails.hasAttribute("open")
    ) {
      userBoxes.forEach((userBox) => userBox.classList.remove("active"));
      loginModal?.classList.add("hidden");
      cartDrawer?.classList.remove("active");
      forceCloseMenuDrawer();
    }
  });
});

searchObserver.observe(searchDetails, {
  attributes: true,
  attributeFilter: ["open"],
});

// Handle menu drawer click
menuDrawer.addEventListener("click", () => {
  userBoxes.forEach((userBox) => userBox.classList.remove("active"));
  searchDetails.removeAttribute("open");
  loginModal?.classList.remove("login-left");
  loginModal?.classList.add("hidden");
  cartDrawer?.classList.remove("active");
});

// Handle cart icon click
cartToggle?.addEventListener("click", () => {
  cartDrawer?.classList.add("active");
  userBoxes.forEach((userBox) => userBox.classList.remove("active"));
  searchDetails.removeAttribute("open");
  loginModal?.classList.add("hidden");
  forceCloseMenuDrawer();
});

// Observe when cart is opened dynamically
if (cartDrawer) {
  const cartObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.attributeName === "class" &&
        cartDrawer.classList.contains("active")
      ) {
        searchDetails.removeAttribute("open");
        userBoxes.forEach((userBox) => userBox.classList.remove("active"));
        loginModal?.classList.add("hidden");
        forceCloseMenuDrawer();
      }
    });
  });

  cartObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

// Set --announcement-height as early as possible (script is deferred, so the DOM
// is parsed by the time this runs).
const announcement = document.querySelector(".announcement-bar-section");
if (announcement instanceof HTMLElement) {
  const announcementHeight = announcement.offsetHeight;
  document.body.style.setProperty(
    "--announcement-height",
    `${announcementHeight}px`,
  );
}
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-wrapper");
  if (header instanceof HTMLElement) {
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
  }

  // Optional: if you want a combined height (announcement + header)
  if (announcement instanceof HTMLElement && header instanceof HTMLElement) {
    const totalHeight = announcement.offsetHeight + header.offsetHeight;
    document.body.style.setProperty(
      "--announcement-header-height",
      `${totalHeight}px`,
    );
  }
});

// PDP See More/Less Set Includes
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-pdp-card]").forEach((card) => {
    const toggle = card.querySelector("[data-toggle]");
    const extra = card.querySelector("[data-extra]");
    const seeMore = card.querySelector(".pdp-see-more-set-includes");
    const seeLess = card.querySelector(".pdp-see-less-set-includes");

    if (toggle && extra) {
      toggle.addEventListener("click", () => {
        const isOpen = extra.classList.contains("show");

        if (isOpen) {
          extra.style.maxHeight = `${extra.scrollHeight}px`;
          requestAnimationFrame(() => {
            extra.style.maxHeight = "0px";
          });
          card.classList.remove("active-card");
        } else {
          extra.style.maxHeight = `${extra.scrollHeight}px`;
          card.classList.add("active-card");
        }

        extra.classList.toggle("show");
        seeMore.classList.toggle("hidden");
        seeLess.classList.toggle("hidden");
      });
    }
  });
});

// cart count update

function setCartCount() {
  setTimeout(() => {
    const countValue = Rebuy.SmartCart.itemCount();

    // Update bubble cart count
    document
      .querySelectorAll(".cart-count-bubble .cart-count-bubble-text")
      .forEach((bubble) => {
        bubble.textContent = countValue;
      });

    // Hide/show the entire cart-count-bubble based on item count
    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      if (countValue < 1) {
        bubble.style.display = "none";
      } else {
        bubble.style.display = ""; // Reset to default display
      }
    });
  }, 400);
}

document.addEventListener("rebuy:cart.ready", setCartCount);
document.addEventListener("rebuy:cart.change", setCartCount);

document.addEventListener("rebuy:cart.change", (event) => {
  const cartItems = event.detail.cart.cart.items;
  processCartData(cartItems);
  setTimeout(() => {
    hideOrShowQuantityWidgets();
  }, 1000);
  setTimeout(() => {
    hideSingleBarProduct();
  }, 1500);
});

function hideSingleBarProduct() {
  const productBlocks = document.querySelectorAll(
    ".rebuy-cart__flyout-recommendations .rebuy-product-block",
  );
  productBlocks.forEach(function (block) {
    const variantTitleElement = block.querySelector(".rebuy-variant-title");
    if (
      variantTitleElement &&
      variantTitleElement.textContent.trim() === "1 bar"
    ) {
      block.classList.add("ctm-hide");
    } else {
      block.classList.remove("ctm-hide");
    }
  });
}

function hideOrShowQuantityWidgets() {
  document.querySelectorAll(".rebuy-cart__flyout-item").forEach((item) => {
    const variantTitle = item
      .querySelector(".rebuy-cart__flyout-item-variant-title")
      ?.textContent.trim();
    const discountMessage = item.querySelector(
      ".rebuy-cart__flyout-item-discount-message",
    );

    if (variantTitle === "1 bar" && discountMessage) {
      item
        .querySelector(".rebuy-cart__flyout-item-quantity-widget")
        .classList.add("ctm-hide");
    } else {
      item
        .querySelector(".rebuy-cart__flyout-item-quantity-widget")
        .classList.remove("ctm-hide");
    }
  });
}

function processCartData(cartItems) {
  let oneBarTotalQuantity = 0;
  const oneBarItems = [];

  cartItems.forEach((item) => {
    if (item.variant_title === "1 bar") {
      oneBarTotalQuantity += item.quantity;
      oneBarItems.push(item.id);
    }
  });
}

function checkElement(selector) {
  return new Promise((resolve, reject) => {
    function check() {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
      } else {
        requestAnimationFrame(check);
      }
    }
    check();
  });
}

function showCustomNote(h4Element) {
  if (!document.querySelector(".rebuy-custom__text")) {
    const customDiv = document.createElement("div");
    customDiv.classList.add("rebuy-custom__text");
    customDiv.innerHTML = `<a href="/pages/build-your-own-soap-pack">Single Bars cannot be added on their own. Please use the Build Your Own Soap Pack Page to choose up to six single bars.</a>`;
    h4Element.insertAdjacentElement("afterend", customDiv);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Scroll instantly to top
  // window.scrollTo(0, 0);

  // Force focus on header so iframe can’t override
  const header = document.querySelector(".header"); // change selector if needed
  if (header) {
    header.setAttribute("tabindex", "-1"); // make focusable
    header.focus();
  }
});

// Double-check after everything loads (iframe included)
window.addEventListener("load", function () {
  setTimeout(function () {
    // window.scrollTo(0, 0);
  }, 200);
});

// YOTPO reward popup
document.addEventListener("click", function (e) {
  if (e.target.closest(".yotpo-button-style[aria-label='REWARDS HISTORY']")) {
    scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.classList.add("yotpo-popup-open");
  }

  if (e.target.closest(".yotpo-close-button")) {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.classList.remove("yotpo-popup-open");
    window.scrollTo(0, scrollY);
  }
});

// document.addEventListener("DOMContentLoaded", () => {
//   console.log("DOM Loaded – script started");

//   function fixRebuyCart() {
//     const menuDrawer = document.querySelector(
//       ".menu-drawer-container.menu-opening",
//     );
//     const rebuyCart = document.querySelector("#rebuy-cart");
//     console.log("Checking classes...");
//     console.log("menuDrawer found:", !!menuDrawer);
//     console.log("rebuyCart:", rebuyCart);
//     if (rebuyCart) {
//       console.log("rebuyCart classes:", rebuyCart.className);
//     }

//     // Condition: Both menu drawer is open AND rebuy-cart has is-visible
//     if (menuDrawer && rebuyCart && rebuyCart.classList.contains("is-visible")) {
//       rebuyCart.classList.remove("is-visible");
//       console.log("➡️ Removed 'is-visible' from #rebuy-cart");
//     }
//   }

//   // Run once on load
//   fixRebuyCart();

//   // Handle cart icon click to restore is-visible class
//   const cartIcon = document.querySelector(".header__icon--cart");
//   if (cartIcon) {
//     cartIcon.addEventListener("click", () => {
//       const rebuyCart = document.querySelector("#rebuy-cart");
//       const searchDetails = document.querySelector("#search-details");
//       if (rebuyCart && !rebuyCart.classList.contains("is-visible")) {
//         rebuyCart.classList.add("is-visible");
//         if (searchDetails && searchDetails.hasAttribute("open")) {
//           searchDetails.removeAttribute("open");
//           console.log("➡️ Removed 'open' attribute from #search-details");
//         }
//         console.log("➡️ Added 'is-visible' to #rebuy-cart on cart click");
//       }
//     });
//     console.log("Cart icon click listener attached");
//   }

//   // Close menu when clicking outside
//   document.addEventListener("click", (e) => {
//     const menuDrawer = document.querySelector(
//       ".menu-drawer-container.menu-opening",
//     );
//     const cartIcon = document.querySelector(".header__icon--cart");
//     const menuContainer = document.querySelector(".menu-drawer-container");

//     // If menu is open and click is outside the menu and cart icon
//     if (
//       menuDrawer &&
//       menuContainer &&
//       !menuContainer.contains(e.target) &&
//       !cartIcon?.contains(e.target)
//     ) {
//       menuDrawer.classList.remove("menu-opening");
//       console.log("➡️ Removed 'menu-opening' class on outside click");
//     }
//   });
//   console.log("Outside click listener attached");

//   // Handle search details click to remove is-visible class
//   const searchDetails = document.querySelector("#search-details");
//   if (searchDetails) {
//     searchDetails.addEventListener("click", () => {
//       const rebuyCart = document.querySelector("#rebuy-cart");
//       if (rebuyCart && rebuyCart.classList.contains("is-visible")) {
//         searchDetails.setAttribute("open", "true");
//         rebuyCart.classList.remove("is-visible");
//         console.log(
//           "➡️ Set open='true' on #search-details and removed 'is-visible' from #rebuy-cart",
//         );
//       }
//     });
//     console.log("Search details click listener attached");
//   }

//   // Watch for class changes dynamically
//   const observer = new MutationObserver((mutations) => {
//     console.log("Mutation detected...");
//     fixRebuyCart();
//   });

//   observer.observe(document.body, {
//     attributes: true,
//     childList: true,
//     subtree: true,
//   });
//   console.log("MutationObserver is running...");
// });

document.addEventListener("DOMContentLoaded", () => {
  /* ------------------------------------
      FUNCTION: Fix Rebuy Cart on menu open
  ------------------------------------ */
  function fixRebuyCart() {
    const menuDrawer = document.querySelector(
      ".menu-drawer-container.menu-opening",
    );
    const rebuyCart = document.querySelector("#rebuy-cart");

    if (menuDrawer && rebuyCart?.classList.contains("is-visible")) {
      rebuyCart.classList.remove("is-visible");
    }
  }

  fixRebuyCart(); // Run once on load

  /* ------------------------------------
      CLOSE MENU ON OUTSIDE CLICK
  ------------------------------------ */
  document.addEventListener("click", (e) => {
    const menuDrawer = document.querySelector(
      ".menu-drawer-container.menu-opening",
    );
    const cartIcon = document.querySelector(".header__icon--cart");
    const menuContainer = document.querySelector(".menu-drawer-container");

    if (
      menuDrawer &&
      menuContainer &&
      !menuContainer.contains(e.target) &&
      !cartIcon?.contains(e.target)
    ) {
      const menuSummary = menuContainer.querySelector("summary");
      if (menuSummary) {
        menuSummary.click();
      } else {
        forceCloseMenuDrawer();
      }
    }
  });

  /* ------------------------------------
      SEARCH CLICK → CLOSE CART
  ------------------------------------ */
  const searchDetails = document.querySelector("#search-details");

  if (searchDetails) {
    searchDetails.addEventListener("click", () => {
      const rebuyCart = document.querySelector("#rebuy-cart");
      document.body.classList.remove("overflow-hidden-tablet");
      if (rebuyCart?.classList.contains("is-visible")) {
        searchDetails.setAttribute("open", "true");
        rebuyCart.classList.remove("is-visible");
        if (!rebuyCart?.classList.contains("is-visible")) {
          document.body.style.setProperty("overflow", "visible", "important");
        }
      }
    });
  }

  /* ------------------------------------
     LOGIN POPUP → CLOSE CART
  ------------------------------------ */
  const accountLogin = document.querySelector(".ctm_account_login");
  const loginBg = document.querySelector(".ctm-login-modal-bg");

  function closeCartIfLoginActive() {
    const rebuyCart = document.querySelector("#rebuy-cart");

    if (!rebuyCart) return;

    const isAccountActive =
      accountLogin?.classList.contains("active") ||
      loginBg?.classList.contains("active");

    if (isAccountActive && rebuyCart.classList.contains("is-visible")) {
      rebuyCart.classList.remove("is-visible");
    }
  }

  const accountLoginButtons = document.querySelectorAll(".ctm_account_login");

  if (accountLoginButtons?.length > 0) {
    accountLoginButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        document.body.classList.remove("overflow-hidden-tablet");
        const accountPopup = document.querySelector(".account-popup");
        if (accountPopup?.classList.contains("hidden")) {
          accountPopup.classList.remove("hidden");
        }
        setTimeout(closeCartIfLoginActive, 150);
      });
    });
  }

  /* ------------------------------------
      CART ICON CLICK → ALWAYS OPEN CART
  ------------------------------------ */
  const cartIcon = document.querySelector(".header__icon--cart");

  if (cartIcon) {
    cartIcon.addEventListener("click", () => {
      const rebuyCart = document.querySelector("#rebuy-cart");
      const searchDetails = document.querySelector("#search-details");
      const accountPopup = document.querySelector(".account-popup");
      document.body.classList.remove("overflow-hidden-tablet");
      // ⭐ ADDED: If menu is open → close it
      const menuDrawer = document.querySelector(
        ".menu-drawer-container.menu-opening",
      );
      if (menuDrawer) {
        const menuSummary = menuDrawer.querySelector("summary");
        if (menuSummary) {
          menuSummary.click();
        } else {
          forceCloseMenuDrawer();
        }
      }

      // Close login modal if open
      if (loginBg?.classList.contains("active")) {
        loginBg.classList.remove("active");
      }

      if (accountLogin?.classList.contains("active")) {
        accountLogin.classList.remove("active");
      }
      const elements = document.querySelectorAll(".ctm_account_login");

      if (elements?.length > 0) {
        elements.forEach((el) => {
          if (el.classList.contains("active")) {
            el.classList.remove("active");
          }
        });
      }

      // ⭐ NEW: Add hidden class to account-popup
      if (accountPopup) {
        accountPopup.classList.add("hidden");
      }

      // OPEN THE CART ALWAYS
      if (rebuyCart && !rebuyCart.classList.contains("is-visible")) {
        rebuyCart.classList.add("is-visible");
      }

      // Close search bar
      if (searchDetails?.hasAttribute("open")) {
        searchDetails.removeAttribute("open");
      }
    });
  }

  /* ------------------------------------
      MUTATION OBSERVER
      Detect dynamic class changes (menu, login, etc.)
  ------------------------------------ */
  const observer = new MutationObserver(() => {
    fixRebuyCart();
    closeCartIfLoginActive();
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ["class"],
  });
});
document.addEventListener(
  "toggle",
  function (e) {
    if (!e.target.matches(".menu-drawer__accordion")) return;
    if (!e.target.open) return;

    document
      .querySelectorAll(".menu-drawer__accordion[open]")
      .forEach(function (el) {
        if (el !== e.target) el.removeAttribute("open");
      });
  },
  true,
);

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".announcement-bar__slider");
  if (!slider) return;

  const slides = slider.children;
  let index = 0;

  function goToSlide(i) {
    slider.style.transform = `translateX(-${i * 100}%)`;
  }

  function nextSlide() {
    index = (index + 1) % slides.length;
    goToSlide(index);
  }

  setInterval(nextSlide, 4000); // adjust timing if needed
});
